import React from 'react'
import { ChapterSection } from './'
import uuid from 'uuid/v1'

export default function Chapter({ chapterTitle, chapterSections }) {
  return (
    <div className='chapter'>

      <h1 className='chapter-title'>{chapterTitle}, Dog</h1>

      {/*
            Iterates over Chapter Sections.
            Passess along Chapter Section Props.
      */}

      {chapterSections.map(chapterSection =>
          <ChapterSection
            sectionType={chapterSection.type}
            sectionTitle={chapterSection.title}
            sectionContent={chapterSection.content}
            key={uuid()}
          />
      )}

    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/BookPrint/Chapter.js